import React from 'react';
import { getEventLink } from '../helper/getEventLink';
import { Link } from 'react-router-dom';
import { formatDateTimeToString } from '../helper/formatDateTimeToString';
import { useTranslate } from './TranslationText';
import { whiteCard } from '../common/cssclasses';
import { getFileName } from '../helper/getFileName';
const BaseURL = process.env.REACT_APP_BASE_URL;

export default function EventCard({ item, getCurrentLanguageUmbraco, totalItems = 2 }) {
    const { translate } = useTranslate();
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    return (
        < >
            {totalItems > 1 ?
                <div
                    draggable='false'
                    className={whiteCard}
                >
                    <div className='col-12 border-15' style={{ maxHeight: 200, overflow: 'hidden' }}>
                        {item.type === 3 ?
                            <div draggable='false' style={{ height: 260, width: '100%', position: 'relative' }}>
                                <img
                                    className='border-15 w-100'
                                    draggable='false'
                                    src={item.coverImage}
                                    // style={{ maxWidth: 400, maxHeight: 245, position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, margin: 'auto' }}
                                    alt={getFileName(item?.coverImage)}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = `${BaseURL}/assets/img/logoerror.png`;
                                    }} />
                            </div>
                            :
                            <img
                                draggable='false'
                                src={item.coverImage}
                                className='border-15 w-100'
                                alt={getFileName(item?.coverImage)}
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = `${BaseURL}/assets/img/logoerror.png`;
                                }} />}
                    </div>
                    <hr className='w-100 my-3' style={{ border: '1px solid var(--dddColor)', height: 0 }} />
                    <div draggable='false' className="row w-100" >
                        <div draggable='false' className="col-12 fw-bold mb-form-group horseCardTitle text-dark" style={{ fontSize: 15 }}>{item.title}</div>
                        <div draggable='false' className="horseCardDescripsiton" style={{ color: '#888888' }}>
                            {formatDateTimeToString(item.start, currentLanguage == 'en' ? 'en-US' : 'ar-AE')} {' - '}
                            {formatDateTimeToString(item.end, currentLanguage == 'en' ? 'en-US' : 'ar-AE')}
                        </div>
                    </div>
                </div>
                :
                <>
                    <div className='row bg-white   scaleHoverEffect ' style={{ borderRadius: 15, overflow: 'hidden', boxShadow: '0px 0px 10px 0px #0000001A' }}>
                        <div className='col-sm-2 col-5 d-flex border-end  border-secondary py-lg-0 py-md-4 py-sm-4 py-5'>
                            {item.type === 3 ?
                                <img
                                    className='w-100 m-auto'
                                    draggable='false'
                                    src={item.coverImage}
                                    // style={{ maxWidth: 400, maxHeight: 245, position: 'absolute', top: 0, right: 0, left: 0, bottom: 0, margin: 'auto' }}
                                    alt={getFileName(item?.coverImage)}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = `${BaseURL}/assets/img/logoerror.png`;
                                    }} />
                                :
                                <img
                                    className='w-100 m-auto'
                                    draggable='false'
                                    src={item.coverImage}
                                    alt={getFileName(item?.coverImage)}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = `${BaseURL}/assets/img/logoerror.png`;
                                    }} />}
                        </div>
                        {/* <div className='col-sm-1 col-1' style={{width:1 , maxWidth:1 , minWidth:1}}>
                            <div className='h-100' style={{ border: '1px solid var(--dddColor)', width: 0 }} />
                        </div> */}
                        <div className='col-sm-9 col-6 d-flex flex-column justify-content-center ps-4 py-lg-0 py-md-4 py-sm-4 py-5'>
                            <div draggable='false' className="card_title text-dark" style={{ fontSize: 15 }}>{item.title}</div>
                            <div draggable='false' className="card_date my-3" style={{ color: '#888888', fontSize: 12 }}>
                                {formatDateTimeToString(item.start, currentLanguage == 'en' ? 'en-US' : 'ar-AE')} {' - '}
                                {formatDateTimeToString(item.end, currentLanguage == 'en' ? 'en-US' : 'ar-AE')}
                            </div>

                        </div>
                    </div>

                </>
            }
        </>
    );
}
